module.exports = __webpack_public_path__ + "img/01chatu1.f923a4bd.png";